import React, { useState, useEffect } from "react";
import HeaderBar from "./components/ClockBar/HeaderBar";
import SopSection from "./components/SopSection/SopSection";
import CommunicationFeed from "./components/Communication/CommunicationFeed";
import DataSelection from "./components/Selection/DataSection";
import Metrics from "./components/Metrics/Metrics";
import Login from "./components/Login/Login";
import FAQ from "./components/FAQ/Faq";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { handleGetActiveAccount, handleSignIn } from "./service/ApiService";

const App: React.FC = () => {

    const getTheme = () => {
        return localStorage.getItem('theme') === 'dark' ? 'dark' : 'light';
    };

    const [theme, setTheme] = useState(getTheme);

    useEffect(() => {
        document.body.className = theme;
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    //use this assignment to enable MSAL
    //const [isLoggedIn, setIsLoggedIn] = useState(!!handleGetActiveAccount());

    //else, use this for disable MSAL
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    const customers = 255;
    const growthPercentage = 27.4;
    const expenses = 150000;
    const projectsCompleted = 15;

    const todayDate = (): string => {
        const today = new Date();
        const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

        return formattedDate;
    }

    const [filter, setFilter] = useState({
        name: "",
        brand: "",
        startDate: "2000-01-01",
        endDate: todayDate(),
    });

    const [messages, setMessages] = useState<any[]>([]);
    const [activePins, setActivePins] = useState<any[]>([]);
    const [progress, setProgress] = useState<boolean>(false);

    const handleFilterChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFilter((prevFilter) => ({ ...prevFilter, [name]: value }));
    };

    const getCurrentConversations = (
        conversations: any[],
        isLoading: boolean
    ) => {
        setMessages(conversations);
        setProgress(isLoading);
    };

    const getActivePins = (activePins: any[]) => {
        setActivePins(activePins);
    };

    useEffect(() => {
        if (!handleGetActiveAccount()) {
            //handleSignIn();
        }
    }, []);

    return (
        <div className={`min-vh-100 App bg-${theme} text-${theme === 'dark' ? 'light' : 'dark'}`}>

            {!isLoggedIn ? (
                <Login onLogin={handleSignIn} />
            ) : (
                <div className="p-4">
                   {/*  <li className="nav-item align-items-center d-flex">
                        <span className="me-2">Change Mode</span>
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" role="switch" id="themingSwitcher" checked={theme === 'dark'} onChange={toggleTheme} />
                        </div>
                    </li> */}
                    <HeaderBar />
                    <div>
                        <div className="row mb-4">
                            <div className="col-12 col-md-3 px-2">
                                <div className="news-header-container">
                                    <SopSection />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 px-1">
                                <div className="data-selection-container">
                                    <DataSelection
                                        data={[]}
                                        filter={filter}
                                        onFilterChange={handleFilterChange}
                                        getCurrentConversations={getCurrentConversations}
                                        setProgress={setProgress}
                                        onFilterActivePins={getActivePins}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-3 px-2">
                                <div
                                    className="communication-feed-container"
                                    style={{ height: "1450px" }}
                                >
                                    <CommunicationFeed
                                        filteredMessages={messages}
                                        progress={progress}
                                        activePins={activePins}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-md-8">
                            <div className="metrics-container">
                                <Metrics
                                    customers={customers}
                                    growthPercentage={growthPercentage}
                                    expenses={expenses}
                                    projectsCompleted={projectsCompleted}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="faq-container">
                                <FAQ />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default App;
